import React from "react";
import { useLocation } from "react-router-dom";
import { useSettings, digits } from "@/context/SettingsContext";

const MSG = "Hello AdiYogi Handcrafts, I'd like to enquire about a product / order.";

// Official-style WhatsApp glyph (single-colour). Uses currentColor so the
// button's text-white gives the classic white icon on the WhatsApp-green pill.
function WhatsAppIcon({ className = "w-7 h-7" }) {
  return (
    <svg
      viewBox="0 0 32 32"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden="true"
    >
      <path d="M19.11 17.59c-.28-.14-1.64-.81-1.89-.9-.25-.09-.44-.14-.62.14-.19.28-.72.9-.88 1.08-.16.19-.32.21-.6.07-.28-.14-1.18-.43-2.25-1.38-.83-.74-1.39-1.66-1.55-1.94-.16-.28-.02-.43.12-.57.13-.13.28-.32.42-.49.14-.16.19-.28.28-.46.09-.19.05-.35-.02-.49-.07-.14-.62-1.5-.85-2.06-.22-.53-.45-.46-.62-.47-.16-.01-.35-.01-.53-.01s-.49.07-.74.35c-.25.28-.97.95-.97 2.32 0 1.37 1 2.69 1.14 2.87.14.19 1.97 3.01 4.79 4.22.67.29 1.19.46 1.6.59.67.21 1.28.18 1.76.11.54-.08 1.64-.67 1.87-1.32.23-.65.23-1.2.16-1.32-.07-.12-.25-.19-.53-.33zM16.03 5.34c-5.9 0-10.68 4.78-10.68 10.68 0 1.88.49 3.71 1.43 5.32L5.35 26.68l5.51-1.44a10.7 10.7 0 0 0 5.16 1.31h.01c5.89 0 10.68-4.78 10.68-10.68a10.6 10.6 0 0 0-3.13-7.55 10.6 10.6 0 0 0-7.55-3.13zm6.24 16.92a8.85 8.85 0 0 1-6.24 2.58h-.01c-1.65 0-3.28-.44-4.7-1.28l-.34-.2-3.5.92.93-3.41-.22-.35a8.85 8.85 0 0 1-1.36-4.72c0-4.9 3.99-8.88 8.89-8.88a8.83 8.83 0 0 1 6.24 2.6 8.83 8.83 0 0 1 2.59 6.29c0 4.89-3.99 8.88-8.28 8.88z"/>
    </svg>
  );
}

export default function WhatsAppFab() {
  const { settings } = useSettings();
  const { pathname } = useLocation();
  const wa = digits(settings.whatsapp_number);
  if (!wa) return null; // Hide the FAB until admin sets a WhatsApp number.
  // On checkout, keep the mobile FAB low-profile so it never covers
  // product details, prices, totals or payment buttons.
  const onCheckout = pathname.startsWith("/checkout");
  const href = `https://wa.me/${wa}?text=${encodeURIComponent(MSG)}`;
  return (
    <>
      {/* Desktop: pill with icon + small "WhatsApp" label */}
      <a
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        className="hidden md:inline-flex fixed bottom-6 right-6 z-40 items-center gap-2 pl-3 pr-4 py-2.5 rounded-full bg-[#25D366] hover:bg-[#1ebe57] text-white shadow-lg transition-transform hover:scale-105"
        aria-label="Chat on WhatsApp"
        data-testid="whatsapp-fab"
      >
        <WhatsAppIcon className="w-6 h-6" />
        <span className="text-sm font-medium">WhatsApp</span>
      </a>

      {/* Mobile: compact circular icon-only button */}
      <a
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        className={`md:hidden fixed ${onCheckout ? "bottom-24 w-11 h-11 left-3" : "bottom-40 w-14 h-14 right-4"} z-30 rounded-full bg-[#25D366] hover:bg-[#1ebe57] text-white shadow-lg flex items-center justify-center transition-transform hover:scale-105`}
        aria-label="Chat on WhatsApp"
        data-testid="whatsapp-fab-mobile"
      >
        <WhatsAppIcon className="w-7 h-7" />
      </a>
    </>
  );
}
